import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AnimationOnScroll } from "react-animation-on-scroll";
import TilesBox from "./Section/TilesBox";

import "./Tiles.scss";

const TilesBlock = ({Module, GQLPage}) => {
    
    var animation_effect = Module.number_of_tiles === "one" ? "animate__fadeInLeftBig" : "animate__fadeInUp"
    var animation_delay = Module.number_of_tiles === "four" ? 4 : 3

    var imagename = (Module.number_of_tiles === "four" || Module.number_of_tiles === "three") ? "pages.tiles_box_component_image.small_tiles_image" : "pages.tiles_box_component_image.large_tiles_image"
    return (
        <React.Fragment>

            <Container>
                <Row>
                    <Col>
                        <div className="tiles-inner" id={Module.id}>
                            {Module.heading_text && <h2>{Module.heading_text}</h2>}

                            <div className={`tiles-wrapper ${Module.number_of_tiles} ${Module.tiles_overlay_color}`}>

                                    {Module.tiles_module.length > 0 && Module.tiles_module.map((item, index) => {

                                        let processedImages = JSON.stringify({});
                                        if (GQLPage?.imagetransforms?.tiles_box_component_image_Transforms) {
                                            processedImages = GQLPage?.imagetransforms?.tiles_box_component_image_Transforms;
                                        }

                                        return(

                                            <div className="tiles_box img-zoom">
                                                <AnimationOnScroll animateIn={animation_effect} delay={(index * 1000)/animation_delay} animateOnce={true}>
                                                    <TilesBox item={item} imagename={imagename} strapi_id={GQLPage.id} processedImages={processedImages} index={index} animation_effect={animation_effect}/>
                                                </AnimationOnScroll>
                                            </div>
 

                                        )
                                    })} 
                           
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>

        </React.Fragment>
    );
};
export default TilesBlock;